<template>
  <div class="worth-container">
    <img src="https://ysh-cdn.kaidicloud.com/test/chamber/banner_member_worth_0.png?0*0" />
    <img src="https://ysh-cdn.kaidicloud.com/test/chamber/banner_member_worth_1.png?1*1" />
    <img src="https://ysh-cdn.kaidicloud.com/test/chamber/banner_member_worth_2.png?2*2" />
    <img mode="widthFix" src="https://ysh-cdn.kaidicloud.com/test/chamber/banner_member_worth_3.png?3*3" />
    <div class="botttom-button">
      <img class="btn" @click="goWxApp()" src="https://ysh-cdn.kaidicloud.com/test/chamber/btn_member_settlement.png" catch:tap="goMemberSettlement" />
    </div>
  </div>
</template>

<script>
import { getWorthUrl } from '@/api/data'
export default {
  data() {
    return {}
  },
  methods: {
    goWxApp() {
      getWorthUrl().then((res) => {
        window.location.href = res.data.data.url
      })
    },
  },
}
</script>

<style lang='less' scoped>
.worth-container {
  display: flex;
  flex-direction: column;
}

.worth-container img {
  width: 100vw;
  height: auto;
}

.botttom-button {
  width: 100vw;
  padding: 20px 0;
  position: fixed;
  bottom: 0;
  left: 0;
  text-align: center;
}

.botttom-button .btn {
  width: 502px;
  height: 118px;
}
</style>

